module.exports = __webpack_public_path__ + "static/og-logo-image-2717067279e17ed974dbda55341d49b9.png";